import profile from './profile'
import master from './master'

export default {
    setting: {
        icon: 'setting',
        text: 'Global Setting',
        route: 'admin.setting',
        children: Object.assign({}, master),
        role: {
            classical: ['admin'],
            paper: ['admin'],
            performance: ['admin'],
            project: ['admin'],
            evaluation: ['admin'],
        }
    },
    materDataTraining: {
        icon: 'hdd',
        text: 'Master Data Pelatihan',
        route: 'master',
        role: {
            classical: [ 'admin' ],
        },
        children: {
            material_classical: {
                icon: null,
                text: 'Materi Klasikal',
                route: 'admin.classical.material',
                role: {
                    classical: [ 'admin' ],
                },
            },
            session_class: {
                icon: null,
                text: 'Sesi Kelas',
                route: 'admin.classical.class.sessions',
                role: {
                    classical: [ 'admin' ],
                },
            },
            userTraining: {
                icon: null,
                text: 'User Klasikal',
                route: 'admin.setting.user',
                role: {
                    classical: [ 'admin' ],
                }
            },
            evaluasi_pelatihan: {
                icon: null,
                text: 'Evaluasi Pelatihan',
                route: 'admin.training-evaluation',
                role: {
                    classical: [ 'admin' ],
                },
            },
            //TODO: Backend belum ada
            pembobotan: {
                icon: null,
                text: 'Pembobotan',
                route: 'admin.classical.weighting',
                role: {
                    classical: [ 'admin' ],
                },
            },
            nilai_wom: {
                icon: null,
                text: 'Nilai WOM',
                route: 'admin.classical.wom',
                role: {
                    classical: [ 'admin' ],
                },
            },
            adminPengumuman: {
                icon: null,
                text: 'Pengumuman',
                route: 'admin.classical.announcement',
                role: {
                    classical: [ 'admin' ],
                },
            },
            adminInformation: {
                icon: null,
                text: 'Information Center',
                route: 'admin.classical.information',
                role: {
                    classical: [ 'admin' ],
                },
            },
        }
    },
}
